/**
 * @file wq-cart-ajax.js
 * @description Shared AJAX Add-to-Cart utility for all four wheels
 * @sprint 0 | Task 0.6 (scaffold)
 */
window.WQ = window.WQ || {};

window.WQ.Cart = (() => {
  'use strict';

  async function addItem(variantId, quantity = 1, properties = {}) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity, properties })
    });
    if (!response.ok) throw new Error(`Cart API error: ${response.status}`);
    return response.json();
  }

  async function addMultipleItems(items) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!response.ok) throw new Error(`Cart API error: ${response.status}`);
    return response.json();
  }

  return { addItem, addMultipleItems };
})();
